import React from "react";
import WalletApi from "../helper/wallet.api";
import { errorHandler, updateLoader } from "./common.utils";

const walletApi = new WalletApi();

export const makeWalletPayment = (data, next) => {
  updateLoader(true);
  walletApi
    .makeWalletPayment(data)
    .then(res => {
      next(res.data.result);
      updateLoader(false);
    })
    .catch(err => {
      updateLoader(false);
      errorHandler(err);
    });
};
